import { format, addDays, isValid, parseISO, addMonths } from 'date-fns';

const parseDate = (date: Date | string): Date => {
  if (date instanceof Date) return date;
  if (typeof date === 'string') return parseISO(date);
  return new Date('');
};

export const isBetweenDates = (start: Date, end: Date): boolean => {
  const now = new Date().getTime();
  return now >= start.getTime() && now <= end.getTime();
};

export const formatDate = (
  date: Date | string,
  dateFormat = 'MMM dd, yyyy'
): string => {
  const parsedDate = parseDate(date);
  return isValid(parsedDate) ? format(parsedDate, dateFormat) : '';
};

export const customAddDays = (
  date: Date | string,
  daysCount: number
): Date | string => {
  const parsedDate = parseDate(date);
  return isValid(parsedDate) ? addDays(parsedDate, daysCount) : '';
};

export const customAddMonths = (
  date: Date | string,
  monthsCount: number
): Date | string => {
  const parsedDate = parseDate(date);
  return isValid(parsedDate) ? addMonths(parsedDate, monthsCount) : '';
};
